import { Text, TextProps } from '@chakra-ui/react';
import { PropsWithChildren } from 'react';

export const DescriptionText = ({ children, ...props }: PropsWithChildren & TextProps) => (
  <Text fontSize="md" color="fg.muted" fontWeight="500" {...props}>
    {children}
  </Text>
);
